import { Link } from "react-router-dom";
import { Search, ArrowRight, Star, CheckCircle2 } from "lucide-react";
import { useContent, mediaUrl } from "../../context/ContentContext";

export default function Hero() {
  const { c } = useContent();
  const h = c.hero;
  return (
    <section className="relative">
      <div className="relative overflow-hidden">
        <img src={mediaUrl(h.image)} alt="Modern residential interior" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 hero-overlay" />
        <div className="relative mx-auto max-w-[1200px] px-5 py-24 lg:px-8 lg:py-32">
          <div className="max-w-2xl section-fade">
            <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3.5 py-1.5 text-[13px] font-semibold text-white backdrop-blur-sm ring-1 ring-white/15">
              <Star size={14} className="fill-amber-400 text-amber-400" />
              {h.badge}
            </span>
            <h1 className="font-display mt-6 text-[46px] font-extrabold leading-[1.04] tracking-tight text-white sm:text-[58px] lg:text-[64px]">
              {h.title}
            </h1>
            <p className="mt-6 max-w-xl text-[17px] leading-relaxed text-slate-200/90">{h.subtitle}</p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/compare" className="group inline-flex items-center gap-2 rounded-xl bg-[var(--brand-blue)] px-6 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-[var(--brand-blue-hover)]">
                {h.primaryCta}
                <ArrowRight size={17} className="transition-transform group-hover:translate-x-1" />
              </Link>
              <Link to="/providers" className="inline-flex items-center gap-2 rounded-xl bg-white px-6 py-3.5 text-[15px] font-semibold text-[var(--ink)] transition-colors hover:bg-slate-100">
                <Search size={17} />
                {h.secondaryCta}
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#f7f8fa]">
        <div className="mx-auto max-w-[1200px] px-5 lg:px-8">
          <div className="grid grid-cols-2 gap-4 -translate-y-8 lg:grid-cols-4 lg:gap-6">
            {c.stats.map((s, i) => (
              <div key={i} className="card-hover rounded-2xl border border-slate-100 bg-white px-6 py-7 shadow-[0_10px_30px_-20px_rgba(15,36,56,0.35)]">
                <div className="font-display text-[30px] font-extrabold text-[var(--ink)] lg:text-[34px]">{s.value}</div>
                <div className="mt-1 text-[14px] font-medium text-slate-500">{s.label}</div>
              </div>
            ))}
          </div>
          <div className="flex flex-wrap items-center gap-x-8 gap-y-3 pb-14">
            {c.trustBadges.map((b, i) => (
              <div key={i} className="flex items-center gap-2 text-[14px] font-medium text-slate-600">
                <CheckCircle2 size={17} className="text-[var(--teal)]" />
                {b}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
